// extracted by mini-css-extract-plugin
module.exports = {"section":"ScenariosHero_section__7DDM2","subtitle":"ScenariosHero_subtitle__T4B1C"};